import { RoleName } from 'domain/User';

export const userRoleTranslate = (role: RoleName): string => {
  switch (role) {
    case RoleName.ADMIN:
      return 'Administrator';
    case RoleName.WAREHOUSEMAN:
      return 'Magazynier';
    case RoleName.VENDOR:
      return 'Handlowiec';
    default:
      return 'Wszystkie';
  }
};

export const userRoleColors = (role: RoleName) => {
  switch (role) {
    case RoleName.ADMIN:
      return '#f50';
    case RoleName.WAREHOUSEMAN:
      return '#108ee9';
    case RoleName.VENDOR:
      return '#276835';
    default:
      return '#fff';
  }
};
